import * as tslib_1 from "tslib";
import { Component, Vue } from "vue-property-decorator";
let LongTextDesign = class LongTextDesign extends Vue {
    render(h) {
        return h('a-textarea', { props: {
                disabled: true,
                placeholder: "请输入"
            } });
    }
};
LongTextDesign = tslib_1.__decorate([
    Component({ name: 'LongTextDesign' })
], LongTextDesign);
export default LongTextDesign;
